<template>
  <div class="productPageList">
    <el-pagination
      class="table-pagination"
      @size-change="handleSizeChange"
      :page-sizes="pageMenu.pageSizes"
      :page-size="pageMenu.pageSize"
      background=""
      :current-page="pageMenu.pageNo"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageMenu.totalCount"
    ></el-pagination>
  </div>
</template>
<script>
export default {
    props: ['pageMenu'],
    methods: {
        handleCurrentChange(val) {
            this.$emit('changeCurrent', val);
        },
        handleSizeChange(val) {
            this.$emit('changeSize', val);
        }
    }
};
</script>
<style>
</style>